"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function AdAdminsAddedManuallyGreyOutline(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 17 17",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    fillRule: "evenodd",
    d: "M4.389 0a4.43 4.43 0 013.856 2.18l-1.089.642A3.166 3.166 0 104.46 7.595l.012 1.265A4.43 4.43 0 014.39 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    fillRule: "evenodd",
    d: "M5.677 4.786c-.267-.205-.465-.269-.64-.269-.146 0-.23.015-.286.044a.22.22 0 00-.073.063.637.637 0 00-.101.214c-.034.113-.02.21.095.359.13.169.34.33.592.504.514.314.974.922 1.322 1.473.368.583.68 1.216.862 1.672l.006.016.883 2.615a.738.738 0 01-1.018.9l-1.874-.899a.966.966 0 00-.452-.024.563.563 0 00-.415.33.666.666 0 00-.023.583c.065.16.171.294.25.373l3.549 1.788.019.011c1.751 1.043 3.353 1.165 3.851 1.117l.023-.002.023-.001c.348-.008 1.527-.263 2.674-1.33.466-.433.686-1.085.739-1.805a5.368 5.368 0 00-.192-1.82l-.002-.005L14.33 6.77a.89.89 0 00-.143-.32.252.252 0 00-.085-.07.402.402 0 00-.18-.034.305.305 0 00-.052.004.398.398 0 00-.025.117 1.2 1.2 0 00.018.321l.18.512-1.153.51a2.684 2.684 0 01-.249-.685l-.05-.142-.008-.043c-.083-.416-.224-.743-.38-.94-.144-.184-.251-.205-.342-.193-.17.021-.21.073-.22.086-.021.027-.056.096-.063.246-.013.316.113.73.24 1.019l-1.144.537-.698-1.41c-.002-.003-.022-.036-.072-.08a.67.67 0 00-.19-.117c-.139-.056-.262-.052-.376.019-.215.131-.29.319-.255.632.033.305.17.634.302.871.016.03.032.057.048.083l-1.087.647a3.875 3.875 0 01-.065-.113l-.09-.163C7.94 7.61 7.57 6.94 6.64 5.796c-.38-.469-.688-.798-.964-1.01zm2.413.808c-.14-.185-.295-.384-.468-.596-.392-.483-.776-.91-1.176-1.216-.41-.313-.872-.53-1.41-.53-.187.001-.528.011-.867.187-.367.19-.652.53-.803 1.036-.183.61.018 1.123.304 1.494.268.347.637.61.895.786l.017.01.016.01c.243.145.576.532.919 1.074.321.51.595 1.065.75 1.451l.472 1.397-.807-.388-.029-.01a2.215 2.215 0 00-1.163-.083c-.483.099-.985.39-1.292 1a1.929 1.929 0 00-.066 1.623c.171.424.453.74.653.91l.057.047 3.654 1.842c1.951 1.155 3.796 1.347 4.578 1.278.674-.024 2.128-.409 3.48-1.666.792-.736 1.075-1.752 1.14-2.64a6.63 6.63 0 00-.242-2.277l-.001-.002-1.155-3.91a2.112 2.112 0 00-.382-.776c-.264-.32-.673-.564-1.243-.564-.253 0-.49.057-.694.174a2.641 2.641 0 00-.03-.04c-.334-.423-.843-.747-1.494-.664-.44.056-.807.24-1.058.561l-.031.041a1.947 1.947 0 00-.428-.239 1.659 1.659 0 00-1.511.115c-.261.16-.451.354-.585.565z",
    clipRule: "evenodd"
  }));
}

AdAdminsAddedManuallyGreyOutline.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
AdAdminsAddedManuallyGreyOutline.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = AdAdminsAddedManuallyGreyOutline;
exports["default"] = _default;